import { createServerOnlyFn } from "@tanstack/react-start";
import { resolveAgentSubjectRoute } from "./route.server.ts";

export const agentSubjectApiRoute = {
    server: {
        handlers: {
            POST: createServerOnlyFn(({ request }: { request: Request }) =>
                resolveAgentSubjectRoute(request),
            ),
        },
    },
};
